
// import cryptojs from 'crypto-js';
 
// const DecryptCode = () => {
//     const secretKey = 'Vishal Enterprise';
//     const encryptedSubUser = localStorage.getItem('PAY_SUB_USER');
//     console.log("encryptedSubUser",encryptedSubUser);
 
//     if (encryptedSubUser) {
//         const subUser = cryptojs.AES.decrypt(encryptedSubUser, secretKey);
//           console.log("subUser",subUser);
//         const descryptVal = subUser.toString(cryptojs.enc.Utf8);
//           console.log("descryptVal",descryptVal);
//         return descryptVal === 'true';
//     }
 
//     return false;
// }
 
// export default DecryptCode;


// src/Components/DecryptCode.js
// import cryptojs from 'crypto-js';

// const DecryptCode = (keyName) => {
    
//   const secretKey = 'Vishal Enterprise';
//   const encryptedVal = localStorage.getItem(keyName);
//  console.log("keyName",keyName);
//  console.log("encryptedVal",encryptedVal);

//   if (encryptedVal) {
//     try {
//       const decrypted = cryptojs.AES.decrypt(encryptedVal, secretKey);
//     console.log("decrypted",decrypted);
//      console.log("sigBytes:", decrypted.sigBytes);
//       const result = decrypted.toString(cryptojs.enc.Utf8);
//       console.log("result",result);
     
//       return result === 'true';
//     } catch (err) {
//       console.error(`Decryption failed for ${keyName}:`, err);
//       return false;
//     }
//   }

//   return false;
// };

// export default DecryptCode;


// src/Components/DecryptCode.js
import CryptoJS from 'crypto-js';

const DecryptCode = (keyName) => {
  const secretKey = 'Vishal Enterprise';
  const encryptedVal = localStorage.getItem(keyName);



  if (encryptedVal) {
    try {
      const decrypted = CryptoJS.AES.decrypt(encryptedVal, secretKey);
  

      const result = decrypted.toString(CryptoJS.enc.Utf8);
   

      // 🔁 Auto-repair logic
      if (!result && decrypted.sigBytes === 0) {
        // fallback value (based on user data, or default)
        const fallback = keyName === 'PAY_BANK_DETAIL' ? 'true' :
                         keyName === 'PAY_SUB_USER'   ? 'false' : 'false';

        const reEncrypted = CryptoJS.AES.encrypt(fallback, secretKey).toString();
        localStorage.setItem(keyName, reEncrypted);
       

        return fallback === 'true';
      }

      return result === 'true';
    } catch (err) {
      
      return false;
    }
  }

  //  Key not found: Set default fallback
  const fallback = keyName === 'PAY_BANK_DETAIL' ? 'true' :
                   keyName === 'PAY_SUB_USER'   ? 'false' : 'false';

  const newEncrypted = CryptoJS.AES.encrypt(fallback, secretKey).toString();
  localStorage.setItem(keyName, newEncrypted);


  return fallback === 'true';
};

export default DecryptCode;

